export type SchemaDetail = {
  vendor: string
  name: string
  format: string
  version: string
}

export type ContextSchema<T = {}> = {
  schema: string
  data: T
}

export const schemaPath = ({ vendor, name, format, version }: SchemaDetail) =>
  `iglu:${vendor}/${name}/${format}/${version}`
